import { createFileRoute } from "@tanstack/react-router";

import { config } from "@/config";

export const Route = createFileRoute("/copilot/$")({
  beforeLoad: () => {
    throw Route.redirect({
      href: config.editorUrl,
      reloadDocument: true,
    });
  },
});
